<template>
  <section v-if="enabled" v-show="eligibleLocation" class="PromotionalTile">
    <h2 class="e2 PromotionalTile__Title" v-if="title">
      <Icon icon="sparkle" />
      <span>{{ title }}</span>
    </h2>
    <div class="PromotionalTile__Container" v-if="tiers.length > 0">
      <ul class="PromotionalTile__Offers">
        <li
          v-for="(tier, index) in tiers"
          :key="tier.code"
          class="PromotionalTile__Offer"
        >
          <div class="PromotionalTile__Icon" :data-tier="`${(index += 1)}`">
            <Icon icon="price-tag" />
          </div>
          <p class="t9 PromotionalTile__Offer-Messaging">
            <span>{{ tierThresholdMessaging(tier) }}</span>
            <span>{{ tierSavingsMessaging(tier) }}</span>
          </p>
        </li>
      </ul>
      <div class="PromotionalTile__Description">
        <div
          class="t5"
          v-if="description('upper')"
          v-html="description('upper')"
        ></div>
        <div
          class="p5"
          v-if="description('lower')"
          v-html="description('lower')"
        ></div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, ref, onBeforeMount } from 'vue';
import Icon from '../Global/Icon.vue';

const props = defineProps({
  tags: Array,
  location: {
    type: String,
    required: false,
    default: '',
  },
});

const promo = ref(false);

const title = computed(() => {
  const data = promo?.value?.tiers ?? false;
  if (!data) return false;

  return data.title !== '' ? data.title : false;
});

const description = computed(() => {
  return (location) => {
    const data = promo?.value?.tiers ?? false;
    const description = data?.descriptions ?? {};
    const content = description[location] ?? '';
    return content !== '' ? atob(content) : false;
  };
});

const enabled = computed(() => {
  const tags = props?.tags ?? [];
  const isEnabled = promo?.value?.tiers?.enabled ?? false;
  const permissionTag = promo?.value?.tiers?.tags ?? '';
  const containsTag = tags.includes(permissionTag) ?? false;

  return isEnabled && containsTag;
});

const eligibleLocation = computed(() => {
  const location = props?.location !== '' ? props.location : false;
  if (!location) return false;

  const notAutoBundleEdit = location !== 'auto-bundle-modal';
  return notAutoBundleEdit;
});

const tiers = computed(() => {
  const data = promo?.value?.tiers ?? false;
  const tiers = data ? [data.tier1, data.tier2, data.tier3] : [];
  const validTiers = tiers.filter((tier) => tier?.code && tier?.code !== '');
  return validTiers;
});

const tierThresholdMessaging = computed(() => {
  return (tier) => {
    const threshold = `$${tier.threshold}`;
    const message = `Spend ${threshold}`;
    return message;
  };
});

const tierSavingsMessaging = computed(() => {
  return (tier) => {
    const savings = `${tier.amount}%`;
    const message = `Save ${savings}`;
    return message;
  };
});

const initializeRequirements = () => {
  const promoObject = window.Brooklinen.promo.discounts;
  promo.value = promoObject;
};

onBeforeMount(() => {
  initializeRequirements();
});
</script>
